import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Toast from "../toast";

const FlashNotice = ({ notice }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!notice) return null;

    // check if there's a single string or an array of notices
    if (typeof notice === 'string') {
      setNotifications([{
        notice,
      }]);
    } else {
      setNotifications(notice);
    }
  }, []);

  return (
    <div className="flex flex-col w-full absolute z-10 mt-3">
      <ul className="list-none p-0 max-w-screen-xl mx-auto w-full pr-6">
        {notifications?.map((notification, index) => (
          <li key={index} className="m-0 pb-2 style-none">
            <Toast {...notification} />
          </li>
        ))}
      </ul>
    </div>
  );
};

FlashNotice.propTypes = {
  notice: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.object),
  ]),
};

export default FlashNotice;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/FlashNotice/index.jsx